import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('preferences', ['billing_info']),
    ...mapState('layouts', ['appConfig']),
    ...mapState('unified_app', ['isUnifiedApp']),
    ...mapState('organization', ['permissions']),
    isQontakOneClient() {
      return Boolean(this.isUnifiedApp || this.permissions?.qontak_one_nav)
    },
    isCompanySettingsLaunchpadEnabled() {
      return Boolean(this.appConfig?.is_company_settings_launchpad)
    },
  },
  methods: {
    goToTopUpPage() {
      /*
        Redirect to new top-up page if the flag is set
        Otherwise, navigate to the old top-up route
        Will add later
      */
      // if (this.billing_info && this.billing_info?.is_new_topup_page) {
      //   window.location.href = `${process.env.HUB_URL}/topup-v2`
      // } else {
      //   this.$router.push('/finances/topup')
      // }
      this.$router.push('/finances/topup')
    },
    goToSubscriptionPage() {
      if (
        this.appConfig &&
        this.appConfig?.is_centralized_package &&
        (this.isUnifiedApp || this.billing_info?.is_qontak_one_package_ui)
      ) {
        window.location.href = `${process.env.HUB_URL}/subscriptions/invoices`
      } else {
        window.location.href = `${process.env.HUB_URL}/settings/subscriptions`
      }
    },
    goToPackageUsagePage() {
      if (
        this.appConfig &&
        this.appConfig?.is_centralized_package &&
        (this.isUnifiedApp || this.billing_info?.is_qontak_one_package_ui)
      ) {
        window.location.href = `${process.env.HUB_URL}/subscriptions/packages`
      } else {
        this.$router.push({ path: '/finances/package_usage' })
      }
    },
    goToCompanySettings() {
      /*
        Qontak One clients with the company-settings Launchpad flag enabled are
        redirected to the external Launchpad company settings page. Everyone else
        (non-Qontak One, flag off, or a missing Launchpad URL) keeps the existing
        internal office hours route.
      */
      const launchpadUrl = process.env.QONTAK_LAUNCHPAD_URL
      if (
        this.isQontakOneClient &&
        this.isCompanySettingsLaunchpadEnabled &&
        launchpadUrl
      ) {
        window.location.href = `${launchpadUrl}/settings/company`
        return
      }
      this.$router.push('/settings/chat/office_hours')
    },
  },
}
